<template>
  <v-container grid-list-md>
    <v-breadcrumbs divider="/">
      <v-breadcrumbs-item
        v-for="item in breadcrumbs"
        :key="item.text"
        :disabled="item.disabled"
        :href="item.href"
      >{{ item.text }}</v-breadcrumbs-item>
    </v-breadcrumbs>
    <br>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap="">
        <v-flex v-for="action in actions" :key="action.ActionName" xs6 md2>
          <v-card
            dark
            class="card status-inactive"
            v-bind:style="{ backgroundColor: action.DropDownsColor }"
          >
            <v-card-text>
              <h4>{{ action.ActionName }}</h4>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'Actions',
  props: {
    id: String
  },
  data() {
    return {
      actions: {},
      user: {},
      breadcrumbs: [
        {
          text: 'Users',
          disabled: false,
          href: '/users'
        },
        {
          text: 'Actions',
          disabled: true
        }
      ]
    };
  },
  methods: {
    viewUser(user) {
      console.log(user);
    },
    getAvatarUrl(user) {
      return 'https://api.adorable.io/avatars/282/' + user.UserID;
    },
    viewAllUsers() {
      console.log('asdfasfasf');
      this.$router.push('/users');
    }
  },
  created() {
    service
      .getUser(this.id)
      .then(response => {
        if (response.data.body.length > 0) {
          this.user = response.data.body[0];
        }
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
    service
      .getUserActions(this.id)
      .then(response => {
        this.actions = response.data.body;
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
  &:first-child {
    margin-left: 0;
  }
}
a {
  color: #42b983;
}
.card {
  background-color: #fff;
}
.status-failed {
  background-color: $color-status-failed;
  border-color: $color-status-failed;
}
.status-inactive {
  background-color: $color-status-inactive;
  border-color: $color-status-inactive;
}
.status-good {
  background-color: $color-status-good;
  border-color: $color-status-good;
}
.action-name {
  overflow: hidden;
}
.card {
  min-height: 120px;
}
</style>
